import { URL } from '../../config.js';
import {axios} from '../../handlers/RequestHandler';
import { tableRemoveAcount , tableUpdate }from './tableActions';
import Notification from '../../handlers/Notification';
//import { b64toBlob } from './UtilsOperation';

const clearAdmin  = () => {
    return (dispatch) => {
        dispatch({
            type: 'CLEAR_ADMIN',
            admin: {},
            dropzoneFiles:[]
        })
    }
}

const show  = () => {
   return (dispatch,getState) => {
        axios.get(URL + getState().company.id +'/admins').then( (res) => {
            dispatch({
                type: 'FETCH_ADMINS',
                admin: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`, msg: err.message
                });
            else{
                Notification.show({
                    type: "error", title:`Error ${err && err.data && err.data.error_code}`,
                    msg: getState().json_lang.custom_errors.retrieving_user_list
                });
            }
        });
    }
}

const find = (id,preloader) => {
    return (dispatch,getState) => {
        if(preloader){
            dispatch({type: "WAIT_FOR_RESPONSE"})
        }
        return axios.get(URL + getState().company.id +'/admins/' + id + '?with=accesses.related_access,city').then( (res) => {
            dispatch({
                type: 'FETCH_ADMIN',
                admin: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`, msg: err.message
                });
            else{
                Notification.show({
                    type: "error", title:`Error ${err && err.data && err.data.error_code}`,
                    msg: getState().json_lang.custom_errors.retrieving_user_data
                });
            }
        });
    }
}

const findSetings = (id) => {
    return (dispatch,getState) => {
        const { company, json_lang, admin} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL+company.id}/admins/${id}/settings`).then( (res) => {
            let update = admin
            update.settings = res.data
            
            dispatch({
                type: 'FETCH_ADMIN',
                admin: update
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`, msg: err.message
                });
            else{
                Notification.show({
                    type: "error", title:`Error ${err && err.data && err.data.error_code}`,
                    msg: json_lang.custom_errors.retrieving_user_data
                });
            }
        });
    }
}
const toggleNotification = (value) => {
    return (dispatch,getState) => {
        var data = getState().showNotification;
        dispatch({
		    type: 'TOOGLE_NOTIFICATIONS',
		    showNotification: !data
		})
    }
}
const toggleData = (value) => {
    return (dispatch,getState) => {
        var data = {
            ...getState().admin,
        }
        if(
            value.name === 'enable_sms' ||
            value.name === 'enable_order_created_sms' ||
            value.name === 'enable_payment_registered_sms' ||
            value.name === 'enable_manual_payment_reported_sms' ||
            value.name === 'enable_order_canceled_sms' ||
            value.name === 'enable_support_sms' ||
            value.name === 'enable_telegram_rates' ||
            value.name === 'enable_telegram_orders' ||
            value.name === 'enable_telegram_reminders' ||
            value.name === 'enable_telegram_alerts'
        ){
           data.settings[value.name] = !data.settings[value.name];
        }else{
            data[value.name] = value.data;
        }
        data.dataUpdated = true;

        dispatch({
		    type: 'FETCH_ADMIN',
		    admin: data
		})
    }
}

const update = (clear, adminData) => {
    return (dispatch,getState) => {
		const { company, json_lang, session, admins } = getState();
        let newAdmin = {
            ...adminData,
        }
        
		dispatch({type: "WAIT_FOR_RESPONSE"})

		return axios.patch(`${URL+ company.id}/admins/${newAdmin.id}`, newAdmin )
		.then( (res) => {
            let newAdmins = { ...admins };
            if(admins && admins.data && admins.data.length > 0){
                const findAdminInAdmins = admins.data.find((admin) => admin.id === newAdmin.id);
                if(findAdminInAdmins){
                    newAdmins.data = admins.data.map((admin) => {
                        if(admin.id === newAdmin.id){
                            return { ...newAdmin, ...res.data };
                        }
                        return admin;
                    });
                }
            }
			if(newAdmin.email !== res.data.email){
				return axios.post(`${URL+ company.id}/accounts/${res.data.account_id}/update-email`, {email: newAdmin.email})
					.then(( resEmail)=> {
						dispatch({type: "REMOVE_LOADING"})
						res.data.email = resEmail.data.email;
						Notification.show({
							type: "success", title:  json_lang.common.success,
							msg: json_lang.custom_success.admin_updated
						});
						res.data.accesses = newAdmin.accesses
                        dispatch({                              
                        	type: 'ADMIN_UPDATE_SUCCESS',
                        	admin: { ...newAdmin, ...res.data },
                            admins: { ...newAdmins },
                        })
                        if(session.id === newAdmin.id){
                            dispatch({
                                type: 'UPDATE_SESSION',
                                session: {...session, ...newAdmin, ...res.data}
                            })
                            localStorage.setItem('user', JSON.stringify({...session, ...newAdmin, ...res.data}));
                        }
					})
					.catch( err => {
						if(err.message && err.message !== 'generic')
							Notification.show({
								type: "error",
								title:`Error ${err && err.data && err.data.error_code}`, msg: err.message
							});
						else{
							if( err.data && err.data.request&& (err.data.request.name === null || err.data.request.phone === null) ){
								Notification.show({
									type: "error",
									title:`Error ${err && err.data && err.data.error_code}`,
									msg: getState().json_lang.custom_errors.empty_fields
								});
							}else{
								Notification.show({
									type: "error",
									title:`Error ${err && err.data && err.data.error_code}`,
									msg: getState().json_lang.custom_errors.user_update_failed
								});
							}
						}
					})
			}
			else {
				Notification.show({
					type: "success", title:  json_lang.common.success,
					msg: json_lang.custom_success.admin_updated
				});
				dispatch({                              
                    type: 'ADMIN_UPDATE_SUCCESS',
                    admin: { ...newAdmin, ...res.data },
                    admins: { ...newAdmins },
                })
                if(session.id === newAdmin.id){
                    dispatch({                              
                        type: 'UPDATE_SESSION',
                        session: { ...session, ...newAdmin, ...res.data}
                    });
                    localStorage.setItem('user', JSON.stringify({ ...session, ...newAdmin, ...res.data}));
                }
			}
            
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`, msg: err.message
                });
            else{
                if( err.data && err.data.request&& (err.data.request.name === null || err.data.request.phone === null) ){
                    Notification.show({
                        type: "error",
                        title:`Error ${err && err.data && err.data.error_code}`,
                        msg: getState().json_lang.custom_errors.empty_fields
                    });
                }else{
                    Notification.show({
                        type: "error",
                        title:`Error ${err && err.data && err.data.error_code}`,
                        msg: getState().json_lang.custom_errors.user_update_failed
                    });
                }
            }
        });
    }
}

const updatePreferences = (admin_id, prefs) => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})

		return axios.patch(`${URL+getState().company.id}/admins/${admin_id}/settings`, prefs)
		.then((res) => {

			// update redux store
			dispatch({
				type: 'ADMIN_UPDATE_PREFERENCES',
                preferences: res.data.preferences
			})

			// update localstorage in case user reload browser
			let session = JSON.parse(localStorage.getItem('user'));
			session.settings.preferences = res.data.preferences;
			localStorage.setItem('user', JSON.stringify(session));

			Notification.show({
                type: "success", title: getState().json_lang.common.success,
                msg:getState().json_lang.custom_success.admin_updated
            });
		})
		.catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`, msg: err.message
                });
            else {
				Notification.show({
					type: "error",
					title:`Error ${err && err.data && err.data.error_code}`,
					msg: getState().json_lang.custom_errors.user_update_failed
				});

            }
        });
    }
}

const updateSettings = (settings) => {
    return (dispatch,getState) => {
        var data = { ...getState().admin }
        let admin = {
            enable_sms:data.settings.enable_sms,
            enable_order_created_sms:data.settings.enable_order_created_sms,
            // enable_payment_registered_sms: data.settings.enable_payment_registered_sms === true ? 1:0,
            enable_manual_payment_reported_sms: data.settings.enable_manual_payment_reported_sms,
            enable_order_canceled_sms: data.settings.enable_order_canceled_sms,
            enable_telegram_rates: data.settings.enable_telegram_rates,
            enable_telegram_orders: data.settings.enable_telegram_orders,
            enable_telegram_reminders: data.settings.enable_telegram_reminders,
            enable_telegram_alerts: data.settings.enable_telegram_alerts,
            // enable_support_sms:data.settings.enable_support_sms === true ? 1:0
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+getState().company.id}/admins/${data.id}/settings`, admin ).then( (res) => {
            dispatch({type: "REMOVE_LOADING"})
            Notification.show({
                type: "success", title: getState().json_lang.common.success,
                msg:getState().json_lang.custom_success.admin_updated
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`, msg: err.message
                });
            else{
                if( err.data && err.data.request&& (err.data.request.name === null || err.data.request.phone === null) ){
                    Notification.show({
                        type: "error",
                        title:`Error ${err && err.data && err.data.error_code}`,
                        msg: getState().json_lang.custom_errors.empty_fields
                    });
                }else{
                    Notification.show({
                        type: "error",
                        title:`Error ${err && err.data && err.data.error_code}`,
                        msg: getState().json_lang.custom_errors.user_update_failed
                    });
                }
            }
        });
    }
}

const updateSmsSettings = (sms,adminId) => {
    return (dispatch,getState) => {

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+getState().company.id}/admins/${adminId}/settings`, sms ).then( (res) => {
            dispatch({type: "REMOVE_LOADING"})
            Notification.show({
                type: "success", title: getState().json_lang.common.success,
                msg:getState().json_lang.custom_success.admin_updated
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`, msg: err.message
                });
            else{
                if( err.data && err.data.request&& (err.data.request.name === null || err.data.request.phone === null) ){
                    Notification.show({
                        type: "error",
                        title:`Error ${err && err.data && err.data.error_code}`,
                        msg: getState().json_lang.custom_errors.empty_fields
                    });
                }else{
                    Notification.show({
                        type: "error",
                        title:`Error ${err && err.data && err.data.error_code}`,
                        msg: getState().json_lang.custom_errors.user_update_failed
                    });
                }
            }
        });
    }
}

const register = (adminData) => {
    return (dispatch,getState) => {
        var data = adminData
        /*var admin = new FormData();

        admin.append('url', window.location.host)
        //admin.append('display_name', data.display_name)
        admin.append('email', data.email)
        admin.append('name', data.name)
        admin.append('phone', data.phone)
        admin.append('password',"secret")

        if(getState().dropzoneFiles.length){
            var block = getState().dropzoneFiles.split(";");
            var contentType = block[0].split(":")[1];
            var realData = block[1].split(",")[1];
            var blob = b64toBlob(realData, contentType);
            admin.append('avatar', blob);
        }else if(data.avatar_url && data.avatar_url.length ){
           admin.append('avatar_url', data.avatar_url)
        }*/
        let admin = {
            name: data.name,
            email: data.email,
            phone: data.phone,
            password: "secret",
            city_id: parseInt(data.city_id,10)
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(URL + getState().company.id +'/admins', admin).then( (res) => {
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.saved_successful
            });
            res.data.accesses = [];
            dispatch({
                type: 'ADMIN_REGISTER_SUCCESS',
                admin: res.data,
            })
        }).catch((err) => {
            console.log('error: ======================================================> ',err);
            if (err.data && err.data.message.indexOf("already_exists") === 0 || err.message === 'The entity already exists')
                Notification.show({ type: "error", title: getState().json_lang.custom_errors.user_registration_failed, msg: getState().json_lang.custom_errors.user_already_exist });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.user_registration_failed });
        });
    }
}

const destroy = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.delete(URL + getState().company.id +'/accounts/'+ id)
        .then( (res) => {
            Notification.show({
                type: "success",
                title: getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.delete_successful
            });
            dispatch({
                type: 'ADMIN_DELETED',
                admins: tableRemoveAcount(res, "admins"),
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.user_delete_failed
            });
        });
    }
}

const restoreAdmin = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(URL + getState().company.id +'/accounts/'+ id + '/restore').then( (res) => {
            Notification.show({
                type: "success",
                title: getState().json_lang.common.success,
                msg:getState().json_lang.custom_success.restored_user
            });
            dispatch({
                type: 'ADMIN_DELETED',
                admins: tableRemoveAcount(res, "admins"),
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.user_restore_failed
            });
        });
    }
}

const disableAdmin = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(URL + getState().company.id +'/accounts/'+ id + '/disable').then( (res) => {
            Notification.show({
                type: "success",
                title: getState().json_lang.common.success,
                msg:getState().json_lang.custom_success.update_successful
            });
            dispatch({
                type: 'ADMIN_UPDATE_SUCCESS',
                admins: tableUpdate(res, "admins"),
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.user_restore_failed
            });
        });
    }
}

const activateAdmin = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(URL + getState().company.id +'/accounts/'+ id + '/activate').then( (res) => {
            Notification.show({
                type: "success",
                title: getState().json_lang.common.success,
                msg:getState().json_lang.custom_success.update_successful
            });
            dispatch({
                type: 'ADMIN_DELETED',
                admins: tableRemoveAcount(res, "admins"),
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.user_restore_failed
            });
        });
    }
}

const accountSettingUpdate = (id,telegram_id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let data = {
            telegram_id: `${telegram_id}`
        }
        
        return axios.patch(`${URL+getState().company.id}/accounts/${id}/settings`,data).then( (res) => {
            
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.user_restore_failed
            });
        });
    }
}
const upgrade = (id, updatedTable = "admins") => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        axios.post(URL + getState().company.id +'/admins/'+ id +'/upgrade')
        .then(() => {

            dispatch(fetchAdmins())
            // dispatch({
            //     type: 'ADMIN_UPDATE_SUCCESS',
            //     admins: tableUpdate(res, updatedTable),
            // });
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.update_successful
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.user_update_failed
            });
        });
    }
}

const downgrade  = (id, updatedTable = "admins" ) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        axios.post(URL + getState().company.id +'/admins/'+ id +'/downgrade')
        .then(() => {
            dispatch(fetchAdmins())
            // dispatch({
            //     type: 'ADMIN_UPDATE_SUCCESS',
            //     admins: tableUpdate(res, updatedTable),
            // })
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.update_successful
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.user_update_failed
            });
        });
    }
}

const sendmail  = (email) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL+getState().company.id}/confirm/${email}?type=admin`).then( (res) => {
           
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.email_sent
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.email_not_sent
            });
        });
    }
}

const fetchAdmins = (page =1,query='',sort='', loader = true) => {
    return (dispatch,getState) => {
        let { company  } = getState();
        if(loader) dispatch({type: "WAIT_FOR_RESPONSE"})
        let url_host = `${URL + company.id}/admins?limit=10&page=${page}&with=account,accesses.related_access`;
		url_host += (query !== '') ? ('&' + query) : '';
        url_host += (sort !== '') ? (`&sort_by=${sort.columnName},${sort.direction}`) : '';
        return axios.get(url_host).then( (res) => {
            dispatch({
                type: 'FETCH_ADMINS',
                admins: res.data
            })
        }).catch((err) => {
            if(loader) dispatch({type: "REMOVE_LOADING"})
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.retrieving_user_list
            });
        });
    }
}

const fetchArchivedAdmins = (page =1,query='',sort='') => {
    
    return (dispatch,getState) => {
        let { company  } = getState();
        let url_host = `${URL+ company.id}/admins?limit=10&page=${page}&with=account,accesses.related_access&mode=deleted`;
		url_host += (query !== '') ? ('&' + query) : '';
        url_host += (sort !== '') ? (`&sort_by=${sort.columnName},${sort.direction}`) : '';
        return axios.get(url_host).then( (res) => {
            dispatch({
                type: 'FETCH_ADMINS',
                admins: res.data
            })
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.retrieving_user_list
            });
        });
    }
}

const fetchSellerAdmins = () => {
    return (dispatch,getState) => {
        return axios.get(`${URL}${getState().company.id}/admins?limit=0&account-type=48`).then( (res) => {
            dispatch({
                type: 'FETCH_ADMINS',
                admins: res.data
            })
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.retrieving_user_list
            });
        });
    }
}

const fetchAvailableCLients = (adminId) => {
    return (dispatch,getState) => {
        return axios.get(`${URL}${getState().company.id}/admins/${adminId}/clients`).then( (res) => {
            let clientsToAsing = [...getState().allClients];
            let assinedClients = res.data.map((client) =>  client.id)
            let avaliableToAsing;

            if(res.data && res.data.length>0){
                avaliableToAsing = clientsToAsing.filter((client) => !assinedClients.includes(client.id));
            }
            dispatch({
                type: 'ATTACHABLE_CLIENS',
                clientsToAsing: res.data,
                allClients: res.data && res.data.length >0 ? avaliableToAsing : clientsToAsing,
            })
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.retrieving_user_list
            });
        });
    }
}

const attachAssigmentClient = (clientId) => {
    return (dispatch,getState) => {
        let clientsToAsing = [...getState().clientsToAsing];
        let allClients = [...getState().allClients];
        let newAssing = allClients.find((client) => client.id === clientId);
        clientsToAsing.push(newAssing)
        let allClientsUpdate = getState().allClients.filter((client) =>  client.id !== clientId )

        dispatch({
            type: 'ATTACHABLE_CLIENS',
            clientsToAsing: clientsToAsing,
            allClients: allClientsUpdate,
        })
    }
}

const dettachAssigmentClient = (clientId) => {
    return (dispatch,getState) => {
        let clientsToAsing = [...getState().clientsToAsing];
        let allClients = [...getState().allClients];

        let avaliableAssing = clientsToAsing.find((client) => client.id === clientId);
        allClients.push(avaliableAssing)

        let allClientsUpdate = clientsToAsing.filter((client) =>  client.id !== clientId )
        dispatch({
            type: 'ATTACHABLE_CLIENS',
            clientsToAsing: allClientsUpdate,
            allClients: allClients,
        })
    }
}

const assigmentClients = (adminId) => {
    return (dispatch,getState) => {
        let assigmentClients= getState().clientsToAsing.map((client) =>  client.id)
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.put(`${URL}${getState().company.id}/admins/${adminId}/clients`,assigmentClients).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg: getState().json_lang.custom_success.saved_successful });
            dispatch({type: 'REMOVE_LOADING'})
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: ""});
        });
    }
}

const GetAdminType = (adminId) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${getState().company.id}/admin-type/${adminId}`).then( (res) => {
            dispatch({
                type: 'FETCH_ADMINTYPE',
                adminType: res.data,
            })
        }).catch((err) => {

        });
    }
}

const GetAllAdminTypes = () => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${getState().company.id}/admin-types?limit=0`).then( (res) => {
           /* let usern1 = {
                id: 11,
                name: "Administrador Ridery",
                default_key: "orders",
                content: [
                    {
                        key: "dashboard",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "map",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "orders",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "categories",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "goods",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "attributes",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "settings",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "clients",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "reports",
                        value: {
                            is_visible: true
                        }
                    }
                ],
                code: 11,
                roles: [],
                uid: 11
            };
            let usern2 = {
                id: 12,
                name: "Órdenes Ridery",
                default_key: "orders",
                content: [
                    {
                        key: "dashboard",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "map",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "orders",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "categories",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "goods",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "attributes",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "settings",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "clients",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "reports",
                        value: {
                            is_visible: true
                        }
                    }
                ],
                code: 12,
                roles: [],
                uid: 12
            }
            res.data.push(otro)
            res.data.push(otro2)*/
            dispatch({
                type: 'FETCH_ALLADMINTYPES',
                allAdminTypes:res.data,
            })
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: ""});
        });
    }
}

const attachAdminTypes = (adminId,adminTypeId) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"});
        const { company, json_lang, admins, allAdminTypes } = getState();
        const prevAdminsData = { ...admins };
        return axios.put(`${URL+company.id}/admins/${adminId}/admin-types/${adminTypeId}`).then(res => {
            const findIndex = prevAdminsData.data.findIndex(admin => admin.id === adminId);
            if(findIndex !== -1){
                const adminType = allAdminTypes.find(type => type.uid === res.data.admin_type_id);
                if(adminType){
                    prevAdminsData.data[findIndex].admin_type = adminType;
                }
            }
            dispatch({
                type: 'FETCH_ADMINS',
                admins: {...prevAdminsData},
            });
            Notification.show({type: "success", title:json_lang.common.success, msg: json_lang.custom_success.saved_successful });
        }).catch((err) => {
            dispatch({type: 'REMOVE_LOADING'});
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: ""});
        });
    }
}

const updateAdminType = (adminType, adminRoles) => {
    return (dispatch, getState) => {
        const { company, json_lang, allAdminTypes } = getState();
        let newAdminTypes = allAdminTypes;
        const newType = {
            ...adminType,
            roles: adminRoles
        }
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.patch(`${URL+company.id}/admin-types/${adminType.uid}`, newType).then(res => {

            const index = newAdminTypes.findIndex(type => type.uid === res.data.uid);
            newAdminTypes[index] = res.data;
            newAdminTypes = [...newAdminTypes];
            dispatch({
                type: 'FETCH_ALLADMINTYPES',
                allAdminTypes:newAdminTypes,
            })
            Notification.show({
                type: "success",
                title: json_lang.common.success,
                msg: json_lang.custom_success.saved_successful
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: ""});
        });
    }
}
const deleteAdminType = (id) => {
    return (dispatch, getState) => {
        const { company, json_lang, allAdminTypes } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.delete(`${URL+company.id}/admin-types/${id}`).then(() => {
            dispatch({
                type: 'FETCH_ALLADMINTYPES',
                allAdminTypes: allAdminTypes.filter(type => type.uid !== id),
            })
            Notification.show({
                type: "success",
                title: json_lang.common.success,
                msg: json_lang.custom_success.delete_successful
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: ""});
        });
    }
}

const createAdminType = (adminType, adminRoles) => {
    return (dispatch, getState) => {
        const { company, json_lang, allAdminTypes } = getState();
        const newType = {
            ...adminType,
            content: [],
            roles: adminRoles
        }
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id}/admin-types`, newType).then(res => {
            const newAdminTypes = [res.data].concat(...allAdminTypes)
            dispatch({
                type: 'FETCH_ALLADMINTYPES',
                allAdminTypes:newAdminTypes,
            })
            Notification.show({
                type: "success",
                title: json_lang.common.success,
                msg: json_lang.custom_success.saved_successful
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: ""});
        });
    }
}

const deleteAdminTypes = (adminId,adminTypeId) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        const { company, json_lang, admins } = getState();
        const prevAdminsData = { ...admins };
        return axios.delete(`${URL+company.id}/admins/${adminId}/admin-types/${adminTypeId}`).then( (res) => {
            const findIndex = prevAdminsData.data.findIndex(admin => admin.id === adminId);
            if(findIndex !== -1){
                prevAdminsData.data[findIndex].admin_type = null;
            }
            dispatch({
                type: 'FETCH_ADMINS',
                admins: {...prevAdminsData},
            });
            Notification.show({type: "success", title:json_lang.common.success, msg: json_lang.custom_success.saved_successful });
        }).catch((err) => {
            dispatch({type: 'REMOVE_LOADING'});
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: ""});
        });
    }
}

const addCompanyAccess = (adminId) => {
    return (dispatch,getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		const { company, json_lang } = getState();

		// creo un objeto en local porque el api solo retorna el Modelo de access, no tiene data sobre el admin
		//!let admin = admins.data.find(a => a.id === adminId)

		const access = {
			"access_type": "company",
			"access_id": company.id
		}
		return axios.post(`${URL+company.id}/admins/${adminId}/admin-accesses`, access)
			.then( (res) => {
				Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.saved_successful });

				/*admin.accesses.push(res.data)
				dispatch({
					type: 'FETCH_ADMINS',
					admins: tableUpdate({data: admin}, "admins"),
				})*/
				dispatch({type: 'REMOVE_LOADING'})
			}).catch((err) => {
				Notification.show({
					type: "error",
					title:`Error ${err && err.data && err.data.error_code}`,
					msg: ""});
			});
    }
}

const removeCompanyAccess = (adminId) => {
    return (dispatch,getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"});
		const { company, json_lang, admins } = getState();

		// creo un objeto en local porque el api solo retorna el Modelo de access, no tiene data sobre el admin
		let admin = admins.data.find(a => a.id === adminId)
		const access_id = admin.accesses.find(a => a.access_type === "company").id;
		// le quito el acceso a company
		admin.accesses = admin.accesses.filter(a => a.access_type !== "company");

		return axios.delete(`${URL + company.id}/admin-accesses/${access_id}`)
			.then((res) => {
				Notification.show({type: "success", title : json_lang.common.success, msg: json_lang.custom_success.delete_successful });
				/*dispatch({
					type: 'FETCH_ADMINS',
					admins: tableUpdate({data: admin}, "admins"),
				})*/
				dispatch({type: 'REMOVE_LOADING'})
			}).catch((err) => {
				Notification.show({
					type: "error",
					title:`Error ${err && err.data && err.data.error_code}`,
					msg: ""});
			});
    }
}



export {
	findSetings,
	addCompanyAccess,
	removeCompanyAccess,
	updatePreferences,
    disableAdmin,
    updateSettings,
    updateSmsSettings,
    GetAllAdminTypes,
	fetchSellerAdmins,
	assigmentClients,
	attachAssigmentClient,
	dettachAssigmentClient,
	fetchAvailableCLients,
    show,
    fetchArchivedAdmins,
    fetchAdmins,
    toggleData,
    restoreAdmin,
    update,
    register,
    find,
    destroy,upgrade,
    downgrade,
    sendmail,
    clearAdmin,
    GetAdminType,
    attachAdminTypes,
    updateAdminType,
    deleteAdminType,
    createAdminType,
    deleteAdminTypes,
    activateAdmin,
    accountSettingUpdate,
    toggleNotification
};



// WEBPACK FOOTER //
// ./src/store/actions/adminActions.js